// Minimal IndexedDB wrapper for RoyalChat Nova offline layer.
const DB_NAME = "royalchat";
const VERSION = 1;
let dbPromise = null;

function open() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains("chats")) db.createObjectStore("chats", { keyPath: "id" });
      if (!db.objectStoreNames.contains("messages")) db.createObjectStore("messages", { keyPath: "id" });
      if (!db.objectStoreNames.contains("outbox")) db.createObjectStore("outbox", { keyPath: "temp_id" });
      if (!db.objectStoreNames.contains("kv")) db.createObjectStore("kv", { keyPath: "k" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

async function tx(store, mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const s = t.objectStore(store);
    const res = fn(s);
    t.oncomplete = () => resolve(res && res.result !== undefined ? res.result : res);
    t.onerror = () => reject(t.error);
  });
}

function getAll(store) {
  return tx(store, "readonly", (s) => s.getAll()).then((r) => (Array.isArray(r) ? r : r && r.result) || []);
}

export const idb = {
  async saveChats(chats) {
    const db = await open();
    const t = db.transaction("chats", "readwrite");
    const s = t.objectStore("chats");
    s.clear();
    chats.forEach((c) => s.put(c));
    return new Promise((res) => (t.oncomplete = res));
  },
  getChats() { return getAll("chats"); },

  async saveMessages(msgs) {
    const db = await open();
    const t = db.transaction("messages", "readwrite");
    const s = t.objectStore("messages");
    msgs.forEach((m) => m && m.id && s.put(m));
    return new Promise((res) => (t.oncomplete = res));
  },
  async getMessages(chatId) {
    const all = await getAll("messages");
    return all.filter((m) => m.chat_id === chatId).sort((a, b) => (a.created_at > b.created_at ? 1 : -1));
  },

  async addOutbox(item) {
    const db = await open();
    const t = db.transaction("outbox", "readwrite");
    t.objectStore("outbox").put(item);
    return new Promise((res) => (t.oncomplete = res));
  },
  getOutbox() { return getAll("outbox"); },
  async removeOutbox(tempId) {
    const db = await open();
    const t = db.transaction("outbox", "readwrite");
    t.objectStore("outbox").delete(tempId);
    return new Promise((res) => (t.oncomplete = res));
  },

  async setKV(k, v) {
    const db = await open();
    const t = db.transaction("kv", "readwrite");
    t.objectStore("kv").put({ k, v });
    return new Promise((res) => (t.oncomplete = res));
  },
  async getKV(k) {
    return tx("kv", "readonly", (s) => s.get(k)).then((r) => (r && r.value ? r.value.v : (r && r.v) || null))
      .catch(() => null);
  },
};
